<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name" style="width:100%">{{pageTitle}}</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!--Forms-->
                <div :class="alertClass" id="success-alert">
                    <strong> {{alertMessage}} </strong>
                </div>
                <div class="forms-container add_user_forms_container">
                    <div class="row no-margin">
                        <!-- Date -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Date :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <VueCtkDateTimePicker v-model="syncResultDate"
                                    range
                                    :only-date="date_picker_options.onlyDate"
                                    :only-time="false"
                                    :output-format="date_picker_options.outputFormat"
                                    :format="date_picker_options.inputFormat"
                                    :formatted="date_picker_options.formatted"
                                    :noClearButton="date_picker_options.noClearButton"
                                    :custom-shortcuts="date_picker_options.customShortcuts"
                                    @input="changeDatePickerDate()"
                                    :maxDate="date_picker_options.maxDate"
                                ></VueCtkDateTimePicker>
                            </div>
                        </div>
                        <!-- Back Order Result -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">
                                    <label class="container" style="width 175px; padding: 0px !important;">
                                        <input type="checkbox" id="checkbox" v-model="isBackOrder">
                                        Back Order Result
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Error Alert-->
                    <div class="row clearfix" >
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="alert alert-danger" id="alertError">
                                <strong id="errorMsg" class="error"></strong>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <!--Buttons-->
                    <div class="row clearfix"></div>
                    <div class="button-demo">
                        <input id="addBenifitBtn" :disabled="disableButtons.save" type="submit" :value="buttonNames.save" class="btn btn-primary" v-on:click.prevent="getSyncResult()">
                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->

            <!-- Missing Invoice Content -->
            <div class="page-header-top-container">
                <div class="page-name" style="width:100%">Missing Invoice</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!-- Forms -->
                <div class="forms-container add_user_forms_container">
                    <div class="row no-margin">
                        <template v-if="!isBranchMissing">
                            <!-- Invoice No -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Invoice No :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input class="form-control" id="invoiceNo" placeholder="Enter Invoice No" v-model="invoiceNo">
                                    <div class="requiredstar">*</div>
                                    <span class="text-danger">{{invoiceNoError}}</span>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <!-- Customer -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Customer :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="customerId"
                                        name="customerId"
                                        id="customerId"
                                        label="text"
                                        :filterable="true"
                                        :options="customerArr"
                                        :clearable=false
                                        @input="onChangeCustomer()"
                                        placeholder="Select Customer">
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <span class="text-danger">{{customerError}}</span>
                                </div>
                            </div>
                            <!-- PO Number -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">PO Number :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input class="form-control" id="poNumber" placeholder="Enter PO Number" v-model="poNumber">
                                    <div class="requiredstar">*</div>
                                    <span class="text-danger">{{poNumberError}}</span>
                                </div>
                            </div>
                        </template>
                        <!-- isBranchMissing -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">
                                    <label class="container" style="width 175px; padding: 0px !important;">
                                        <input type="checkbox" id="checkbox" v-model="isBranchMissing">
                                        Barnch Missing
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <!--Buttons-->
                    <div class="row clearfix"></div>
                    <div class="button-demo">
                        <input id="addBenifitBtn" :disabled="disableButtons.invoice" type="submit" :value="buttonNames.invoice" class="btn btn-primary" v-on:click.prevent="getMissingInvoice()">
                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
            <!-- Missing Invoice Content -->
            <div class="page-header-top-container">
                <div class="page-name" style="width:100%">New Sync Result</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!-- Forms -->
                <div class="forms-container add_user_forms_container">
                    <div class="row no-margin">
                        <!-- Customer -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Customer :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="newCustomerId"
                                    name="newCustomerId"
                                    id="newCustomerId"
                                    label="text"
                                    :filterable="true"
                                    :options="customerArr"
                                    :clearable=false
                                    @input="onChangeNewCustomer()"
                                    placeholder="Select Customer">
                                </v-select>
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{newCustomerError}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <!--Buttons-->
                    <div class="row clearfix"></div>
                    <div class="button-demo">
                        <input id="addBenifitBtn" :disabled="disableButtons.newsync" type="submit" :value="buttonNames.newsync" class="btn btn-primary" v-on:click.prevent="newSyncResult()">
                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import Footer from '@/components/partials/Footer';
    import EventBus from '.././event-bus';
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common.js';
    var moment = require('moment-timezone');

    export default {
        name: 'SyncResult',
        mixins: [commonMixins],
        components: {
            'app-footer': Footer,
            'v-select': vSelect,
        },
        data() {
            return {
                pageTitle : "Sync Result",
                alertClass : '',
                alertMessage : '',

                syncResultDate: '',
                date_picker_options: {
					range: true,
					onlyDate: true,
					outputFormat: 'YYYY-MM-DD',
					inputFormat: 'YYYY-MM-DD',
					formatted: 'MMM DD, YYYY',//'YYYY-MM-DD', 
					noClearButton: true,
					maxDate : '',
					customShortcuts : [
						{ key: 'yesterday', label: 'Yesterday', value: '-day', isSelected: true },
						{ key: 'thisWeek', label: 'This Week', value: 'isoWeek', isSelected: false },
						{ key: 'lastWeek', label: 'Last Week', value: '-isoWeek', isSelected: false },
						{ key: 'thisMonth', label: 'This Month', value: 'month', isSelected: false },
						{ key: 'lastMonth', label: 'Last Month', value: '-month', isSelected: false },
					]
                },
                isBackOrder: 0,
                isBranchMissing: 0,
                invoiceNo: '',
                invoiceNoError: '',
                newCustomerId: "",
                customerId: "",
                customerArr: [],
                customerError: "",
                newCustomerError: "",
                poNumber: "",
                poNumberError: "",

                buttonNames : {
                    save : 'Sync',
                    invoice: 'Save',
                    newsync: 'Sync',
                },
                disableButtons : {
                    save : false,
                    invoice: false,
                    newsync: false,
                },
            }
        },
        beforeMount: function () {
            self = this;
            EventBus.$emit("menu-selection-changed", "syncResult");
        },
        watch: {
            isBranchMissing: function(isBranchMissing) {
                self.invoiceNoError = "";
                self.customerError = "";
                self.poNumberError = "";
            }
        },
        mounted: function () {
            $("#alertError").hide();
            self.getAllCustomer();
        },
        methods: {
            changeDatePickerDate : function () {
            },
            onChangeCustomer:function() {
                self.customerError = "";
            },
            onChangeNewCustomer: function() {
                self.newCustomerError = "";
            },
            getAllCustomer: function() {
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                };
                HTTP.get('/customer/all/get', config)
                    .then(function (response) {
                        if (response.status == '200') {
                            self.customerArr = response.data.content;
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err);
                    })
            },
            getSyncResult: function() {
                var fromDate = '';
                var toDate = '';
                if(self.syncResultDate != '') {
                    if (self.syncResultDate.end === null) {
                        self.syncResultDate.end = self.syncResultDate.start;
                    }
                    fromDate = self.syncResultDate.start;
                    toDate = self.syncResultDate.end;
                }
                self.buttonNames.save = "Syncing ...";
                self.disableButtons.save = true;
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                    params: {
                        is_back_order: self.isBackOrder ? 0 : 1,
                        from_date: fromDate,
                        to_date: toDate,
                        tz: moment.tz.guess(),
                    }
                };
                HTTP.get('/sync/result', config)
                    .then(response => {
                        self.buttonNames.save = "Sync";
                        self.disableButtons.save = false;
                        if (response.status == "200") {
                            self.resetVarialble();
                            // location.href = response.data.content.web;
                            self.downloadFile(response.data.content.web);
                        }
                    })
                    .catch(function (err) {
                        self.buttonNames.save = "Sync";
                        self.disableButtons.save = false;
                        if (err.response.status == 0) {
                            //self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //self.$router.push("/login");
                            }
                            //self.error = err.response.data.message;
                        }
                    });
            },
            validateForm: function() {
                var error = true;
                self.customerError = '';
                self.poNumberError = '';
                self.invoiceNoError = '';

                if(self.isBranchMissing) {
                    if (self.customerId == null || !self.customerId.excede_id) {
                        self.customerError = "The Customer field is required.";
                        error = false;
                    }
                    if (!self.poNumber) {
                        self.poNumberError = "Please Enter PO Number.";
                        error = false;
                    }
                } else {
                    if (!self.invoiceNo) {
                        self.invoiceNoError = "Please Enter Invoice No.";
                        error = false;
                    }
                }
                return error;
            },
            getMissingInvoice: function() {
                setTimeout(() => {
                    if (self.validateForm()) {
                        self.buttonNames.invoice = "Saving ...";
                        self.disableButtons.invoice = true;
                        var config = {
                            headers: {
                                Authorization:localStorage.getItem("access_token")
                            },
                            params: {
                                is_branch_missing: self.isBranchMissing,
                                invoice_no: self.invoiceNo,
                                po_number: self.poNumber,
                                customer_excede_id: self.isBranchMissing ? self.customerId.excede_id : '',
                            }
                        };
                        HTTP.get('/invoice/missing', config)
                            .then(response => {
                                self.buttonNames.invoice = "Save";
                                self.disableButtons.invoice = false;
                                if (response.status == "200") {
                                    self.resetVarialble();
                                    // location.href = response.data.content.web;
                                    self.downloadFile(response.data.content.web);
                                }
                            })
                            .catch(function (err) {
                                self.buttonNames.invoice = "Save";
                                self.disableButtons.invoice = false;
                                if (err.response.status == 0) {
                                    //self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        //self.$router.push("/login");
                                    }
                                    //self.error = err.response.data.message;
                                }
                            });
                    }
                }, 200);
            },
            resetVarialble: function() {
                self.syncResultDate = "";
                self.isBackOrder = 0;
                self.isBranchMissing = 0;
                self.invoiceNo = "";
                self.poNumber = "";
                self.customerId = "";
                self.newCustomerId = "";
            },
            checkForm: function() {
                var checked = true;
                if (self.newCustomerId == null || !self.newCustomerId.excede_id) {
                    self.newCustomerError = "Please select customer.";
                    checked = false;
                }
                return checked;
            },
            newSyncResult: function() {
                setTimeout(() => {
                    if (self.checkForm()) {
                        self.buttonNames.newsync = "Syncing ...";
                        self.disableButtons.newsync = true;
                        var config = {
                            headers: {
                                Authorization:localStorage.getItem("access_token")
                            },
                            params: {
                                customer_excede_id: self.newCustomerId.excede_id
                            }
                        };
                        HTTP.get('/new/sync/result/get', config)
                            .then(response => {
                                self.buttonNames.newsync = "Sync";
                                self.disableButtons.newsync = false;
                                if (response.status == "200") {
                                    self.resetVarialble();
                                    // location.href = response.data.content.web;
                                    self.downloadFile(response.data.content.web);
                                } else {
                                    self.showSAlert(response.data.message, 'info', false);
                                }
                            })
                            .catch(function (err) {
                                self.buttonNames.newsync = "Sync";
                                self.disableButtons.newsync = false;
                                if (err.response.status == 0) {
                                    //self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        //self.$router.push("/login");
                                    }
                                    //self.error = err.response.data.message;
                                }
                            });
                    }
                }, 200);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/InternalUseComponent/SyncResult.vue